import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  const dark = tone === "dark";
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-76" data-mp="3c3yysrhwio94">
      <p className={`flex items-center gap-2 text-center text-xs font-bold uppercase tracking-wider sm:text-sm ${dark ? "text-wine-100" : "text-wine-700"}`} data-id="element-77" data-mp="3h2jzst4z9bym">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="3729ml8iy04jg" />
        The special launch offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-79" data-mp="10c3crffr7dyu">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-80" data-mp="15bochs2qzqcm" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-81" data-mp="159bytr40w25d">
              <span className={`flex h-[72px] w-[72px] items-center justify-center rounded-xl font-serif text-4xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-[42px] ${dark ? "bg-white text-wine-900" : "bg-wine-900 text-white"}`} data-id="element-82" data-mp="y04xs77s3ssm">
                {String(unit.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-wine-200" : "text-ink-soft"}`} data-id="element-83" data-mp="f22i4j14f87h">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${dark ? "text-white" : "text-wine-900"}`} data-id="element-84" data-mp="o4k02l9qteoo">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}